import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";

// 👇 Prevent browser from restoring a scrolled-down position on reload
if ("scrollRestoration" in window.history) {
  window.history.scrollRestoration = "manual";
}

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
